import React from 'react'
import intl from 'react-intl-universal'

interface RegenErrorCodeProps {
  errorCode: number
}

export default function RegenErrorCode({ errorCode }: RegenErrorCodeProps) {
  function showErrorMessage(code: number) {
    const errors = {
      404: intl.get('canonicalUrl.regenAll.error.notFound'),
      423: intl.get('canonicalUrl.regenAll.error.locked'),
    }

    return errors[code] ?? intl.get('canonicalUrl.regenAll.error.general')
  }
  return <span className="ml-2">{showErrorMessage(errorCode)}</span>
}
